import { useTranslation } from 'react-i18next';

import { Box, Text, VStack } from '@bonusly/design-system';
import { useCurrentCompany } from '@bonusly/who-am-i';

import { GithubConnectCard } from '../github/github-connect-card';
import { GranolaConnectCard } from '../granola/granola-connect-card';
import { LinearConnectCard } from '../linear/linear-connect-card';
import { SlackConnectCard } from '../slack/slack-connect-card';

export const ConnectorsSection = () => {
	const { t } = useTranslation('admin_bizy');
	const company = useCurrentCompany();

	const hasGranola = company?.bizy_connectors_granola;
	const hasLinear = company?.bizy_connectors_linear;
	const hasGithub = company?.bizy_connectors_github;
	const hasSlack = company?.bizy_connectors_slack;

	if (!hasGranola && !hasLinear && !hasGithub && !hasSlack) return null;

	return (
		<Box>
			<Box pb={3} borderBottom="1px solid" borderColor="border.soft">
				<Text size="md" color="text.softest">
					{t('settingsPanel.sectionIntro.connections')}
				</Text>
			</Box>
			<VStack spacing={0} align="stretch">
				{hasGranola && <GranolaConnectCard />}
				{hasLinear && <LinearConnectCard />}
				{hasGithub && <GithubConnectCard />}
				{hasSlack && <SlackConnectCard />}
			</VStack>
		</Box>
	);
};
